import React from 'react';
import { Alert } from 'antd';
import { TDataset } from '../../../models/aibuilder/aibuilder';
import { getDatasetDiagnostics } from '../engine/datasetDiagnostics';

export interface DatasetDiagnosticsPanelProps {
  dataset: TDataset;
  accuracy: number | null;
  extraIssues?: string[];
}

const DatasetDiagnosticsPanel: React.FC<DatasetDiagnosticsPanelProps> = ({ dataset, accuracy, extraIssues }) => {
  const issues = [...getDatasetDiagnostics(dataset, accuracy), ...(extraIssues || [])];
  if (issues.length === 0) return null;
  return (
    <Alert
      type="warning"
      showIcon
      message="Comment améliorer la précision"
      description={
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {issues.map((issue, index) => (
            <li key={index}>{issue}</li>
          ))}
        </ul>
      }
      style={{ marginTop: 16, marginBottom: 16 }}
    />
  );
};

export default DatasetDiagnosticsPanel;
